import { render, staticRenderFns } from "./GuidanceBanner.vue?vue&type=template&id=4fb3450a&"
import script from "./GuidanceBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GuidanceBanner.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports